/* ==========================================================================
   custom-overrides.js — amazonasfoods.com store customizations
   --------------------------------------------------------------------------
   This file is NOT part of the Xtra theme. It is loaded last (after
   custom.js and page-collection.js) from layout/theme.liquid, so anything in
   here can safely build on top of the theme's own JavaScript.

   Rule: put behaviour tweaks HERE instead of editing custom.js,
   page-collection.js or a section's inline <script>. On the next Xtra update
   this file survives untouched and only needs a quick re-test.

   Each block is numbered to match MODIFICATIONS.md.
   ========================================================================== */

(function () {
	'use strict';

	/* ----------------------------------------------------------------------
	   #13  Collection pages: infinite scroll

	   When the collection section's "Pagination type" is set to
	   "Infinite scroll", sections/main-collection.liquid renders a hidden
	   marker element (#collection-infinite-scroll) alongside the theme's
	   normal load-more markup.

	   This watches the theme's own "Show more products" button and clicks it
	   as it comes into view, so the shopper just keeps scrolling. Everything
	   else — the fetch, the append, the URL update, re-initialising quick
	   buy / ratings / swatches — is still done by the theme's existing
	   handler in page-collection.js. We only supply the click.

	   Deliberately conservative:
	   - Only [data-next] is ever auto-clicked. The "Show previous products"
	     and "Back to top" buttons are left alone.
	   - One load at a time; the next click can't fire until the theme has
	     announced the previous one finished.
	   - The same URL is never fetched twice.
	   - If JavaScript fails or IntersectionObserver is missing, the button
	     is still there and still works by hand. Nothing is hidden.
	   ---------------------------------------------------------------------- */

	var LOAD_AHEAD_PX = 600; // start loading this far before the button is on screen
	var MAX_AUTO_LOADS = 200; // runaway guard; ~10,000 products at 48/page

	var observer = null;
	var observedButton = null;
	var isLoading = false;
	var autoLoadCount = 0;
	var seenHrefs = Object.create(null);

	function isEnabled() {
		return !!document.getElementById('collection-infinite-scroll');
	}

	function disconnect() {
		if (observer) {
			observer.disconnect();
		}
		observedButton = null;
	}

	function handleIntersect(entries) {
		for (var i = 0; i < entries.length; i++) {
			if (!entries[i].isIntersecting) continue;

			var button = entries[i].target;
			if (isLoading) return;
			if (button.classList.contains('loading')) return;

			// The theme binds its click handler on the collectionLoadMore
			// event. If we somehow got here first, wait for the next tick.
			if (button.getAttribute('data-collection-load-more-bound') !== '1') return;

			var href = button.getAttribute('href');
			if (!href || seenHrefs[href]) return;

			if (autoLoadCount >= MAX_AUTO_LOADS) {
				disconnect();
				return;
			}

			seenHrefs[href] = true;
			autoLoadCount++;
			isLoading = true;

			// Stop watching the current button; the theme replaces it with a
			// fresh one and then fires collectionLoadMore, which re-binds us.
			disconnect();
			button.click();
			return;
		}
	}

	function init() {
		isLoading = false;

		if (!isEnabled()) {
			disconnect();
			return;
		}

		if (typeof window.IntersectionObserver !== 'function') return;

		var button = document.querySelector('#load-more-button[data-next]');

		if (!button) {
			disconnect();
			return;
		}

		if (button === observedButton) return;

		disconnect();

		if (!observer) {
			observer = new IntersectionObserver(handleIntersect, {
				root: null,
				rootMargin: LOAD_AHEAD_PX + 'px 0px',
				threshold: 0
			});
		}

		observedButton = button;
		observer.observe(button);
	}

	// The theme fires this after every load-more append and after every
	// filter / sort update, which is exactly when the button is replaced.
	window.addEventListener('collectionLoadMore', function () {
		// Let the theme finish swapping the DOM in before we look for it.
		requestAnimationFrame(init);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


(function () {
	'use strict';

	/* ----------------------------------------------------------------------
	   #14  Boxify cart-based bot protection

	   Boxify returns no shipping rates for a cart unless every line item
	   carries the hidden property  _checkout_method = verified_human
	   (https://kb.boxifyapp.com/pages/article_035.html). Bots that jump
	   straight to checkout never get it, so they can't find shipping.

	   Follows Boxify's article: the Checkout button is hidden and a
	   "Click here to verify you are human" button is shown in its place.
	   Pressing it stamps every cart line, then reveals Checkout.

	   Three things the article's sample doesn't do, added here because each
	   one would otherwise let a REAL customer reach checkout unstamped and
	   find no shipping:

	   1. The cart forms carry a hidden "checkout" field, so pressing Enter
	      in a quantity box submits straight to checkout. Any such submit is
	      intercepted and the cart stamped first.
	   2. The cart drawer redraws itself whenever something is added. Buttons
	      are found by delegation, so a redrawn drawer is handled too.
	   3. Adding an item after verifying leaves that line unstamped, so the
	      verify step comes back when the cart changes.

	   The stamp is only ever applied in response to a click or keypress,
	   never on page load — stamping automatically would stamp bots too.

	   Buy it now and the Shop Pay / Apple Pay / Google Pay buttons skip the
	   cart entirely, so they are switched off in the theme settings.
	   ---------------------------------------------------------------------- */

	var PROPERTY = '_checkout_method';
	// Boxify's article (corrected 28 Sep 2026) specifies "verified_human".
	// This must match exactly what Boxify checks for, or NO cart gets rates.
	var VALUE = 'verified_human';

	var PENDING_CLASS = 'amz-verify-pending'; // on <html> while unstamped
	var BUTTON_CLASS = 'amz-verify-btn';
	var DONE_CLASS = 'amz-verify-done';

	var TEXT = {
		en: {
			verify: 'Click here to verify you are human',
			working: 'Verifying…',
			done: 'Verified — you can now check out.',
			error: "We couldn't get your cart ready for checkout. Please try again."
		},
		es: {
			verify: 'Haz clic aquí para verificar que eres humano',
			working: 'Verificando…',
			done: 'Verificado: ya puedes finalizar la compra.',
			error: 'No pudimos preparar tu carrito para el pago. Por favor, inténtalo de nuevo.'
		}
	};

	function t(key) {
		var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
		return (TEXT[lang] || TEXT.en)[key];
	}

	function root() {
		var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
		return r || '/';
	}

	var busy = false;       // a stamping run is in flight
	var verified = false;   // every line in the cart carries the property
	var allowed = new WeakSet();
	var checking = false;
	var lastCheck = 0;

	/* ---------------------------------------------------------- cart plumbing */

	function getCart() {
		return fetch(root() + 'cart.js', {
			credentials: 'same-origin',
			headers: { Accept: 'application/json' },
			cache: 'no-store'
		}).then(function (res) {
			if (!res.ok) throw new Error('cart.js ' + res.status);
			return res.json();
		});
	}

	function isStamped(item) {
		return !!(item.properties && item.properties[PROPERTY] === VALUE);
	}

	function stamp(item) {
		var properties = {};
		var existing = item.properties || {};
		for (var k in existing) {
			if (Object.prototype.hasOwnProperty.call(existing, k)) properties[k] = existing[k];
		}
		properties[PROPERTY] = VALUE;

		var body = { id: item.key, quantity: item.quantity, properties: properties };
		if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
			body.selling_plan = item.selling_plan_allocation.selling_plan.id;
		}

		return fetch(root() + 'cart/change.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify(body)
		}).then(function (res) {
			if (!res.ok) throw new Error('cart/change.js ' + res.status);
			return res.json();
		});
	}

	// Stamp one line at a time, re-reading the cart after each change, since
	// changing a line's properties gives it a new key.
	// Resolves with the number of lines that needed stamping.
	function ensureStamped() {
		var stamped = 0;
		var guard = 0;

		function pass() {
			return getCart().then(function (cart) {
				if (guard === 0) guard = cart.items.length * 2 + 3;
				for (var i = 0; i < cart.items.length; i++) {
					if (!isStamped(cart.items[i])) {
						if (--guard < 0) throw new Error('stamping did not settle');
						stamped++;
						return stamp(cart.items[i]).then(pass);
					}
				}
				return stamped;
			});
		}
		return pass();
	}

	/* ------------------------------------------------------------ the button */

	function setVerified(state) {
		verified = state;
		document.documentElement.classList.toggle(PENDING_CLASS, !state);
	}

	function checkoutButtons() {
		return document.querySelectorAll('button[name="checkout"], input[type="submit"][name="checkout"]');
	}

	function makeButton(model) {
		var btn = document.createElement('button');
		btn.type = 'button';
		btn.className = BUTTON_CLASS + ' ' + (model.className || '');
		btn.textContent = t('verify');

		var msg = document.createElement('p');
		msg.className = DONE_CLASS;
		msg.setAttribute('role', 'status');
		msg.textContent = t('done');

		var holder = document.createElement('div');
		holder.className = 'amz-verify';
		holder.appendChild(btn);
		holder.appendChild(msg);
		return holder;
	}

	// Put a verify button next to every checkout button that hasn't got one.
	function inject() {
		var buttons = checkoutButtons();
		for (var i = 0; i < buttons.length; i++) {
			var target = buttons[i];
			if (target.getAttribute('data-amz-verify') === '1') continue;
			target.setAttribute('data-amz-verify', '1');
			var holder = makeButton(target);
			// sits directly above the checkout button, inside the same wrapper
			target.parentNode.insertBefore(holder, target);
		}
	}

	function setButtonsBusy(on) {
		var btns = document.querySelectorAll('.' + BUTTON_CLASS);
		for (var i = 0; i < btns.length; i++) {
			btns[i].disabled = on;
			btns[i].classList.toggle('loading', on);
			btns[i].textContent = on ? t('working') : t('verify');
		}
	}

	function clearErrors() {
		var old = document.querySelectorAll('.amz-checkout-error');
		for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
	}

	function showError(anchor) {
		clearErrors();
		var p = document.createElement('p');
		p.className = 'amz-checkout-error';
		p.setAttribute('role', 'alert');
		p.textContent = t('error');
		var host = (anchor && anchor.closest && anchor.closest('.amz-verify, p, div')) || anchor;
		if (host && host.parentNode) host.parentNode.insertBefore(p, host.nextSibling);
		else document.body.appendChild(p);
	}

	/* --------------------------------------------------------- state syncing */

	// Re-read the cart and update the verified flag. Debounced, because the
	// theme redraws the drawer on every add / quantity change.
	function refresh(force) {
		var now = Date.now();
		if (checking || (!force && now - lastCheck < 1000)) return Promise.resolve();
		checking = true;
		lastCheck = now;
		return getCart().then(function (cart) {
			setVerified(cart.items.length > 0 && cart.items.every(isStamped));
		}).catch(function () {
			setVerified(false); // if in doubt, ask for verification
		}).then(function () {
			checking = false;
			inject();
		});
	}

	/* ------------------------------------------------------------- behaviour */

	// The verify button.
	document.addEventListener('click', function (event) {
		var btn = event.target && event.target.closest && event.target.closest('.' + BUTTON_CLASS);
		if (!btn) return;
		event.preventDefault();
		if (busy) return;
		busy = true;
		clearErrors();
		setButtonsBusy(true);

		ensureStamped().then(function () {
			busy = false;
			setButtonsBusy(false);
			setVerified(true);
		}).catch(function (err) {
			busy = false;
			setButtonsBusy(false);
			showError(btn);
			if (window.console) console.error('[checkout protection]', err);
		});
	});

	// Safety net 1: any submit that would reach checkout — including Enter in
	// a quantity box — stamps first if it somehow hasn't happened yet.
	document.addEventListener('submit', function (event) {
		var form = event.target;
		var submitter = event.submitter || null;
		if (!form || !form.elements) return;
		if (!(submitter && submitter.name === 'checkout') && !form.elements.namedItem('checkout')) return;
		if (allowed.has(form)) { allowed.delete(form); return; }

		event.preventDefault();
		event.stopImmediatePropagation();
		if (busy) return;
		busy = true;

		var button = submitter || form.querySelector('[name="checkout"]:not([type="hidden"])');
		clearErrors();

		ensureStamped().then(function (stamped) {
			setVerified(true);
			if (stamped === 0) {
				// Nothing changed, so the form's quantity fields still line up
				// with the cart: hand it back to the browser untouched.
				busy = false;
				allowed.add(form);
				if (typeof form.requestSubmit === 'function') {
					form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
				} else {
					form.submit();
				}
				return;
			}
			// Lines were re-keyed; save the note and go straight to checkout.
			var note = null;
			for (var i = 0; i < form.elements.length; i++) {
				if (form.elements[i].name === 'note') note = form.elements[i].value;
			}
			var done = function () { window.location.href = root() + 'checkout'; };
			if (note === null) return done();
			return fetch(root() + 'cart/update.js', {
				method: 'POST',
				credentials: 'same-origin',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({ note: note })
			}).catch(function () {}).then(done);
		}).catch(function (err) {
			busy = false;
			showError(button || form);
			if (window.console) console.error('[checkout protection]', err);
		});
	}, true);

	// Safety net 2: links straight to checkout (apps sometimes add one).
	document.addEventListener('click', function (event) {
		var link = event.target && event.target.closest && event.target.closest('a[href]');
		if (!link) return;
		if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
		var url;
		try { url = new URL(link.href, window.location.href); } catch (e) { return; }
		if (url.origin !== window.location.origin) return;
		if (!/\/checkout\/?$/.test(url.pathname)) return;

		event.preventDefault();
		if (busy) return;
		busy = true;
		clearErrors();
		ensureStamped().then(function () {
			window.location.href = url.href;
		}).catch(function (err) {
			busy = false;
			showError(link);
			if (window.console) console.error('[checkout protection]', err);
		});
	}, true);

	/* ----------------------------------------------------------------- start */

	// Hide Checkout immediately, before anything is painted, then let the
	// cart check decide whether it should come back.
	setVerified(false);

	function start() {
		inject();
		refresh(true);

		// The drawer and the cart page redraw on every change; re-inject and
		// re-check when they do.
		if (typeof window.MutationObserver === 'function') {
			var timer = null;
			new MutationObserver(function () {
				if (busy) return;
				clearTimeout(timer);
				timer = setTimeout(function () { refresh(false); }, 300);
			}).observe(document.body, { childList: true, subtree: true });
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', start);
	} else {
		start();
	}
})();
